import { linkElement, serializableLinkElement } from './linkify';
import { paragraphElement } from './paragraph';
import { divElement } from './div';
import { brElement } from './br';

export const options = {
  ...linkElement,
  ...paragraphElement,
  ...divElement,
  ...brElement,
};

export const serializableOptions = {
  ...serializableLinkElement,
  ...paragraphElement,
  ...divElement,
  ...brElement,
};
